<template>
  <div class="my-lists">
    <div class="row">
      <div class="col-md-8 contents">
        <h4 class="title">My Listings</h4>
        <perfect-scrollbar>
          <ContentsList
            ref="contentsList"
            @edit="onEditContent"
            :types="types"
            v-model="checked"
            :search="search"
            :sortBy="sort"
            :sortAscending="sortAscending"
          />
        </perfect-scrollbar>
      </div>
      <perfect-scrollbar class="col-md-4 filter ps-filter">
        <!-- <FilterList
          @onAdd="onClickAdd"
          @onClickChangeStatus="onClickStatus"
          @search="onSearch"
        /> -->
        <FilterList>
          <template v-slot:header>Listing Options</template>
          <template v-slot:btn>
            <div class="mb-2">
              <button
                class="btn btn-secondary rounded mr-2"
                @click="onClickStatus('PUBLISH')"
              >
                <i class="far fa-eye"></i>
                PUBLISH
              </button>
              <button
                class="btn btn-secondary rounded"
                @click="onClickStatus('UNPUBLISH')"
              >
                <i class="far fa-eye-slash"></i>
                UNPUBLISH
              </button>
            </div>
            <div class="button-add">
              <button
                class="btn btn-secondary btn-block rounded"
                @click="onAdd('experience')"
              >
                ADD EXPERIENCE
              </button>
              <button
                class="btn btn-secondary btn-block rounded"
                @click="onAdd('tour')"
              >
                ADD TOUR
              </button>
              <button
                class="btn btn-secondary btn-block rounded"
                @click="onAdd('event')"
              >
                ADD EVENT
              </button>
              <button
                class="btn btn-secondary btn-block rounded"
                @click="onAdd('story')"
              >
                ADD STORY
              </button>
            </div>
          </template>
          <template v-slot:headerfilter>Filter Listings</template>
          <template v-slot:filter
            ><form @submit.prevent="onSearch">
              <div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search content"
                    aria-label="Search content"
                    aria-describedby="basic-addon2"
                    v-model="filters.search"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2">
                      <i class="fas fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 py-1">
                  <button class="btn btn-status btn-block">Approved</button>
                </div>
                <div class="col-md-4 py-1">
                  <button class="btn btn-status btn-block">Pending</button>
                </div>
                <div class="col-md-4 py-1">
                  <button class="btn btn-status btn-block">Rejected</button>
                </div>
                <div class="col-md-4 py-1">
                  <button class="btn btn-status btn-block">Published</button>
                </div>
                <div class="col-md-4 py-1">
                  <button class="btn btn-status btn-block">Unpublished</button>
                </div>
                <div class="col-md-4 py-1">
                  <button class="btn btn-status btn-block">Incomplete</button>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 py-1">
                  <button
                    class="btn btn-experiences btn-block"
                    :class="{ active: btn.experience }"
                    @click="addTypes('experience')"
                  >
                    Experiences
                  </button>
                </div>
                <div class="col-md-4 py-1">
                  <button
                    class="btn btn-tours btn-block"
                    :class="{ active: btn.tour }"
                    @click="addTypes('tour')"
                  >
                    Tours
                  </button>
                </div>
                <div class="col-md-4 py-1">
                  <button
                    class="btn btn-events btn-block"
                    :class="{ active: btn.event }"
                    @click="addTypes('event')"
                  >
                    Events
                  </button>
                </div>
                <div class="col-md-4 py-1">
                  <button
                    class="btn btn-stories btn-block"
                    :class="{ active: btn.story }"
                    @click="addTypes('story')"
                  >
                    Stories
                  </button>
                </div>
              </div>
              <div class>
                <select v-model="filters.sort" class="form-control">
                  <option value="TITLE">Sort by title</option>
                  <option value="CREATED_AT">Sort by date posted</option>
                </select>
              </div>
              <div class>
                <div class="row">
                  <div class="col-md-6">
                    <button class="btn btn-apply btn-block" type="submit">
                      <span></span>
                      <span>APPLY</span>
                      <i class="fas fa-check"></i>
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button class="btn btn-reset btn-block" @click="onReset">
                      <span></span>
                      <span>RESET FILTERS</span>
                      <i class="fas fa-redo"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </template>
        </FilterList>
      </perfect-scrollbar>
    </div>
    <transition name="fade">
      <ExperienceForm
        v-if="showExperienceForm"
        @close="onClose"
        :content="content"
      />
      <EventForm v-if="showEventForm" @close="onClose" :content="content" />
      <TourForm v-if="showTourForm" @close="onClose" :content="content" />
      <StoriesForm v-if="showStoryForm" @close="onClose" :content="content" />
    </transition>
  </div>
</template>

<script>
import img01 from "@/assets/images/img-list-01.png";
import FilterList from "@/components/Filter";
// import FilterList from "@/components/Lists/Filter";
import ContentsList from "@/components/Lists/ContentsList";
import ExperienceForm from "@/components/ExperienceForm";
import EventForm from "@/components/EventForm";
import StoriesForm from "@/components/Contents/Stories/StoriesForm";
import TourForm from "@/components/TourForm";

const defaultTypes = ["experience", "event", "tour", "story"];
const defaultSort = "CREATED_AT";

export default {
  name: "MyLists",
  components: {
    FilterList,
    ContentsList,
    ExperienceForm,
    EventForm,
    StoriesForm,
    TourForm,
  },
  data() {
    return {
      img01: img01,
      content: null,
      showExperienceForm: false,
      showEventForm: false,
      showTourForm: false,
      showStoryForm: false,
      search: "",
      types: [...defaultTypes],
      sort: defaultSort,
      sortAscending: false,
      checked: [],
      btn: {
        experience: false,
        tour: false,
        event: false,
        story: false,
      },
      filters: {
        search: "",
        types: [...defaultTypes],
        sort: defaultSort,
      },
    };
  },
  methods: {
    onAdd(type) {
      if (type == "experience") {
        this.showExperienceForm = true;
      }

      if (type == "event") {
        this.showEventForm = true;
      }

      if (type == "tour") {
        this.showTourForm = true;
      }

      if (type == "story") {
        this.showStoryForm = true;
      }
    },
    onClose() {
      this.showExperienceForm = false;
      this.showEventForm = false;
      this.showTourForm = false;
      this.showStoryForm = false;
      this.reload();
    },
    onReset() {
      this.search = "";
      this.types = [...defaultTypes];
      this.sort = defaultSort;
      this.filters.search = "";
      this.filters.types = [...defaultTypes];
      this.filters.sort = defaultSort;
      this.btn.experience = false;
      this.btn.tour = false;
      this.btn.event = false;
      this.btn.story = false;
    },
    reload() {
      this.content = null;
      this.$refs.contentsList.reload();
    },
    async onEditContent(id, type) {
      if (type == "experience") {
        this.content = await this.$repo.exp.getExperience(id);
        this.showExperienceForm = true;
      }

      if (type == "event") {
        this.content = await this.$repo.event.getEvent(id);
        this.showEventForm = true;
      }

      if (type == "tour") {
        this.content = await this.$repo.tour.getTour(id);
        this.showTourForm = true;
      }

      if (type == "story") {
        this.content = await this.$repo.story.getStory(id);
        this.showStoryForm = true;
      }
    },
    onClickStatus(status) {
      if (!this.checked || this.checked < 1) return;

      this.$repo.statusContent
        .batchUpdateContentStatus(this.checked, status)
        .then((result) => {
          this.checked = [];
          this.reload();
        });
    },
    onSearch() {
      this.search = this.filters.search;
      this.types = [...this.filters.types];
      this.sort = this.filters.sort;console.log(this.search);

      if (this.sort == "TITLE") {
        this.sortAscending = true;
      } else {
        this.sortAscending = false;
      }

      this.reload();
    },
    addTypes(type) {
      const index = this.filters.types.indexOf(type);
      if (index > -1) {
        this.filters.types.splice(index, 1);
      } else {
        this.filters.types.push(type);
      }

      if (type == "experience") {
        this.btn.experience = !this.btn.experience;
      }

      if (type == "tour") {
        this.btn.tour = !this.btn.tour;
      }

      if (type == "event") {
        this.btn.event = !this.btn.event;
      }

      if (type == "story") {
        this.btn.story = !this.btn.story;
      }
    },
  },
};
</script>

<style lang="scss">
.my-lists {
  .ps {
    height: 80vh;
  }

  .ps-filter {
    height: 86vh;
    overflow: hidden;
  }

  .contents {
    order: 1;
  }

  .filter {
    order: 2;
  }

  @media only screen and (max-width: 480px) {
    .contents {
      order: 2;
      padding-bottom: 50px;
    }

    .filter {
      order: 1;
    }
  }
}
h4.title {
  color: var(--primary-color);
}
</style>